export const SrTagsWrapper =
  'flex items-center gap-2 py-2 rounded-md hover:bg-opacity-80 transition'
